<template>
  <div class="pthv-form pthvSchedule-form">

    <select v-model="selectedLine" class="form-select" @change="selectLine">
      <option value="all">{{ $t("chooseLine") }}</option>
      <template v-if="withDestinations && hasCategories">
        <optgroup v-for="(lineCategory, categoryKey) in stopsByLineCategorised" :label="lineCategory.category">
          <template v-for="(lineStops, lineKey) in lineCategory.lineStops">
            <ApthScheduleLineOptions v-for="(stop, destKey) in lineStops.stopsByDestinations"
              :categoryKey="categoryKey" :lineKey="lineKey" :finalKey="destKey" 
              :lineMnemo="lineStops.line.mnemo" :stop="stop" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
            />
          </template>
        </optgroup>
      </template>
      <template v-else-if="withDestinations">
        <template v-for="(lineCategory, categoryKey) in stopsByLineCategorised">
          <template v-for="(lineStops, lineKey) in lineCategory.lineStops">
            <ApthScheduleLineOptions v-for="(stop, destKey) in lineStops.stopsByDestinations"
              :lineKey="lineKey" :finalKey="destKey" 
              :lineMnemo="lineStops.line.mnemo" :stop="stop" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
            />
          </template>
        </template>
      </template>
      <template v-else-if="hasCategories">
        <optgroup v-for="(lineCategory, categoryKey) in stopsByLineCategorised" :label="lineCategory.category">
          <ApthScheduleLineOptions v-for="(stop, lineKey) in lineCategory.lineStops"
            :stop="stop" :finalKey="lineKey" :categoryKey="categoryKey" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
          />
        </optgroup>
      </template>
      <template v-else>
        <template v-for="(lineCategory, categoryKey) in stopsByLineCategorised">
          <ApthScheduleLineOptions v-for="(stop, lineKey) in lineCategory.lineStops" 
            :stop="stop" :finalKey="lineKey" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
          />
        </template>
      </template>
    </select>
  </div>
</template>

<script>
//Components
import ApthScheduleLineOptions from "./ApthScheduleLineOptions";

export default {
  name: "ApthScheduleForm",
  components: {
    ApthScheduleLineOptions,
  },
  data() {
    return {
      selectedLine: "all",
      selectedStop: "all",
      stopsRefs: [],
      optionSeparator: "||",
    };
  },
  props: {
    lines: {
      type: Object,
      required: true,
      default: () => {
        return [];
      }
    },
    stopsByLineCategorised: {
      type: Array,
      required: true,
      default: [],
    },
    stops: {
      type: Object,
      required: true,
      default: () => {
        return [];
      }
    },
    withDestinations: {
      type: Boolean,
      required: false,
      default: true
    },
    hasCategories: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    selectLine: function() {
      let ss = this.stops;
      const expandName = function(stopRef) {
        return {
          name: ss[stopRef].name,
          refs: [stopRef]
        };
      };

      const uniqueStopsRefs = function(stopsRefs) {
        // Transform objects to strings
        let comparablesStops = stopsRefs.map(
          s => s.name + "<>" + s.refs.join("§")
        );
        // Make unique
        let uniqueStops = new Set(comparablesStops);
        //Reconstruct arrays
        return Array.from(uniqueStops).map(str => {
          let parts = str.split("<>");
          let name = parts[0];
          let refs = parts[1].split("§");
          return {
            name: name,
            refs: refs
          };
        });
      };

      const mergeStopareas = function(stopareas) {
        let merged = [];
        for (let stoparea of stopareas) {
          if (Object.keys(merged).indexOf(stoparea.name) < 0) {
            merged[stoparea.name] = stoparea;
          } else {
            merged[stoparea.name].refs = merged[stoparea.name].refs.concat(
              stoparea.refs
            );
          }
        }
        return Object.values(merged);
      };

      let selectedLineParts = String(this.selectedLine).split(this.optionSeparator);
      let categoryId = selectedLineParts[0];
      let lineId = selectedLineParts[1];

      // We have no values if 'all' is selected
      // Check the values before building stops list
      if (this.stopsByLineCategorised[categoryId] !== undefined && lineId !== undefined) {
        let stopsByLine = this.stopsByLineCategorised[categoryId].lineStops[lineId];
        let stopareas;
        if (this.withDestinations) {
          let direction = selectedLineParts[2];
          let stopsByDestination = stopsByLine.stopsByDestinations[direction];
          stopareas = stopsByDestination.stopsRefs.map(expandName);
        } else {
          stopareas = stopsByLine.stopsByDestinations.flatMap(stopsByDest =>
            stopsByDest.stopsRefs.map(expandName)
          );
        }
        this.stopsRefs = uniqueStopsRefs(mergeStopareas(stopareas));

        this.$emit("selectLine", stopsByLine.line);
      } else {
          this.$emit("selectLine", []);
      }
    }
  }
};
</script>

<style lang="scss">

.pthvSchedule-form {
  display: grid;
  row-gap: 1rem;
  padding: 0.25rem;
  margin-block-end: 1rem;
}

.form-select {
  width: 100%;
}
</style>
